// main.js — bootstrap: build state, wire engine, controller, input, views.

import { createInitialState } from "./core/GameState.js";
import { GameEngine } from "./core/GameEngine.js";
import { TextAliveController } from "./core/TextAliveController.js";
import { InputController } from "./input/InputController.js";
import { BoardView } from "./view/BoardView.js";
import { HudView } from "./view/HudView.js";
import { BeatTrackView } from "./view/BeatTrackView.js";

function boot() {
    const state = createInitialState();
    const engine = new GameEngine(state);

    // Clear any DOM left over from a previous (HMR) run before re-injecting.
    document.getElementById("media").replaceChildren();
    document.getElementById("board-root").replaceChildren();
    document.getElementById("beat-track").replaceChildren();

    const board = new BoardView(document.getElementById("board-root"));
    const hud = new HudView({
        scoreEl: document.getElementById("score"),
        stepsEl: document.getElementById("steps"),
        lineEl: document.getElementById("lyric-line"),
        statusEl: document.getElementById("status"),
    });
    const beatTrack = new BeatTrackView(document.getElementById("beat-track"));

    // Discrete state changes -> re-render everything.
    engine.subscribe((s) => {
        board.render(s);
        hud.render(s);
        beatTrack.render(s);
    });

    const input = new InputController(engine, document.getElementById("stage"));
    input.attach();

    const music = new TextAliveController(engine, document.getElementById("media"));

    // Continuous per-frame clock -> tempo-reactive visuals.
    music.onFrame((frame) => {
        beatTrack.setPlaying(frame.isPlaying); // green while playing, white otherwise
        beatTrack.pulse(frame.beat ? frame.beat.progress : 0);
    });

    // Play/pause: tap the stage, click the pause button, or press Esc.
    const stageEl = document.getElementById("stage");
    const pauseBtn = document.getElementById("pause-btn");
    const onStageClick = () => music.togglePlay();
    const onPauseClick = (e) => { e.stopPropagation(); music.togglePlay(); };
    const onKey = (e) => {
        if (e.key === "Escape") { e.preventDefault(); music.togglePlay(); }
    };
    stageEl.addEventListener("click", onStageClick);
    pauseBtn.addEventListener("click", onPauseClick);
    window.addEventListener("keydown", onKey);

    const teardown = () => {
        stageEl.removeEventListener("click", onStageClick);
        pauseBtn.removeEventListener("click", onPauseClick);
        window.removeEventListener("keydown", onKey);
    };

    // Initial paint.
    board.render(state);
    hud.render(state);
    beatTrack.render(state);

    return { engine, music, input, teardown };
}

const app = boot();

// HMR: dispose the old player + input before the module re-runs in dev,
// so reloads don't stack duplicate media widgets or double-bind input.
if (typeof module !== "undefined" && module.hot) {
    module.hot.dispose(() => {
        app.input.detach();
        app.music.dispose();
        app.teardown();
    });
    module.hot.accept();
}
